import styled from 'styled-components';

import { device } from 'styles/breakpoints';

export const ThankYouWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;

  @media ${device.tablet} {
    margin-top: 70px;
  }
`;

export const ThankYouImageWrapper = styled.div`
  margin-bottom: 20px;
`;

export const ThankYouDescription = styled.div`
  margin-top: 20px;

  h1 {
    font-size: 40px;
    font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
    color: ${({ theme }) => theme.colors.green};
  }

  p {
    font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
    font-size: 17px;
    margin-top: 15px;
  }

  @media ${device.tablet} {
    h1 {
      font-size: 35px;
    }

    p {
      font-size: 16px;
    }
  }

  p > a {
    color: ${({ theme }) => theme.colors.green};
    text-decoration: underline;
  }
`;
